import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="bg-[#330000] text-white"
      style={{ fontFamily: "'Montserrat', sans-serif" }}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Col 1: Logo + desc */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/dd390f0ef03d8b86574cad703c5770ab.jpg"
              alt="GIROBUIT - Vaciado de pisos y locales en Girona"
              title="GIROBUIT - Empresa de vaciado de pisos y locales en Girona"
              className="h-14 w-auto object-contain mb-4"
              width={140}
              height={56}
              loading="lazy"
              decoding="async"
            />
            <p className="text-sm text-red-200 leading-relaxed">
              Especialistas en vaciado de pisos y locales en Girona. Servicio discreto, profesional y con presupuesto sin compromiso.
            </p>
            <div className="flex gap-3 mt-5">
              <a
                href="tel:+34602365996"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#ff0000]/20 hover:bg-[#ff0000] transition-colors duration-200 cursor-pointer"
                aria-label="Llamar a GIROBUIT"
              >
                <i className="ri-phone-fill text-sm"></i>
                <span className="sr-only">Llamar a GIROBUIT</span>
              </a>
              <a
                href="https://wa.me/34602365996"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#ff0000]/20 hover:bg-[#25D366] transition-colors duration-200 cursor-pointer"
                aria-label="WhatsApp GIROBUIT"
              >
                <i className="ri-whatsapp-line text-sm"></i>
                <span className="sr-only">WhatsApp GIROBUIT</span>
              </a>
              <a
                href="mailto:info@girobuit.com"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#ff0000]/20 hover:bg-[#ff0000] transition-colors duration-200 cursor-pointer"
                aria-label="Email GIROBUIT"
              >
                <i className="ri-mail-fill text-sm"></i>
                <span className="sr-only">Email GIROBUIT</span>
              </a>
            </div>
          </div>

          {/* Col 2: Servicios */}
          <div>
            <h3 className="text-base font-700 mb-5 text-[#FF6666]" style={{ fontWeight: 700 }}>
              <Link to="/servicios" className="hover:text-white transition-colors cursor-pointer">Servicios</Link>
            </h3>
            <ul className="space-y-2.5 text-sm text-red-200">
              <li><Link to="/servicios#vaciado-pisos" className="hover:text-white transition-colors cursor-pointer">Vaciado de pisos y casas</Link></li>
              <li><Link to="/servicios#vaciado-locales" className="hover:text-white transition-colors cursor-pointer">Vaciado de locales comerciales</Link></li>
              <li><Link to="/servicios#retirada-muebles" className="hover:text-white transition-colors cursor-pointer">Retirada de muebles</Link></li>
              <li><Link to="/servicios#limpieza-diogenes" className="hover:text-white transition-colors cursor-pointer">Limpieza síndrome de Diógenes</Link></li>
              <li><Link to="/servicios#pintura" className="hover:text-white transition-colors cursor-pointer">Pintura final</Link></li>
            </ul>
          </div>

          {/* Col 3: Áreas */}
          <div>
            <h3 className="text-base font-700 mb-5 text-[#FF6666]" style={{ fontWeight: 700 }}>
              Área de Servicio
            </h3>
            <ul className="space-y-2 text-sm text-red-200">
              <li>Vaciado de pisos en Girona</li>
              <li>Vaciado de pisos en Salt</li>
              <li>Vaciado en Sarrià de Ter</li>
              <li>Vaciado en Banyoles</li>
              <li>Cassà de la Selva · Celrà</li>
              <li>Toda la comarca del Gironès</li>
            </ul>
          </div>

          {/* Col 4: Contacto */}
          <div>
            <h3 className="text-base font-700 mb-5 text-[#FF6666]" style={{ fontWeight: 700 }}>
              <Link to="/contacto" className="hover:text-white transition-colors cursor-pointer">Contacto</Link>
            </h3>
            <ul className="space-y-3 text-sm text-red-200">
              <li className="flex items-start gap-2">
                <i className="ri-phone-fill mt-0.5 text-[#FF6666]"></i>
                <a href="tel:+34602365996" className="hover:text-white transition-colors cursor-pointer">602 36 59 96</a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-fill mt-0.5 text-[#FF6666]"></i>
                <a href="mailto:info@girobuit.com" className="hover:text-white transition-colors cursor-pointer">info@girobuit.com</a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-fill mt-0.5 text-[#FF6666]"></i>
                <span>Girona, Catalunya</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-fill mt-0.5 text-[#FF6666]"></i>
                <span>Lun–Vie: 8:00–19:00<br />Sáb: 9:00–14:00</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Subfooter */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-red-300">
          <span>© {new Date().getFullYear()} GIROBUIT. Todos los derechos reservados.</span>
          <div className="flex flex-wrap justify-center sm:justify-end gap-4">
            <Link to="/aviso-legal" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Aviso legal</Link>
            <Link to="/privacidad" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Política de privacidad</Link>
            <Link to="/cookies" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap" aria-label="Política de cookies de GIROBUIT">Política de cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
